import { DIRECTIVE_DENSITY, ID_DENSITY, DIRECTIVE_DESIGN, DENSITIES } from './constants';
import { load } from './load';
import { updateCss } from './updateCss';

export function getDensity(name) {
  const design = document.documentElement.getAttribute(DIRECTIVE_DESIGN) ?? 'smartadmin';
  return DENSITIES[design]?.[name] ?? '';
}

export function updateDensity() {
  const densityUrl = document.documentElement.getAttribute(DIRECTIVE_DENSITY);
  if ('custom' === densityUrl) {
    return;
  }

  if (['default', 'comfortable', 'compact'].includes(densityUrl)) {
    updateCss(getDensity(densityUrl), ID_DENSITY);
  } else {
    densityUrl &&
      load(densityUrl, ID_DENSITY).catch(e => {
        console.error(e);
      });
  }
}
